import { z } from 'zod';

import { CAPABILITIES, CLERK_ORG_ROLES } from '../../libs/auth/rbac';

/**
 * #2851's denied state on the wire.
 *
 * The granting roles travel as DATA, so a client renders the reason it was given
 * instead of re-deriving policy from a table it happens to have imported. Both
 * ends parse this schema, which is what stops the API body and the notice from
 * drifting apart.
 */
export const PermissionStateSchema = z.object({
  capability: z.enum(CAPABILITIES).nullable(),
  grantingRoles: z.array(z.enum(CLERK_ORG_ROLES)),
  reason: z.enum([
    'invalid_capability',
    'key_ceiling',
    'no_principal',
    'not_granted',
    'unknown_role',
  ]),
});
export type PermissionStateBody = z.infer<typeof PermissionStateSchema>;

/** The one 403 body every RBAC-gated route returns. */
export const ForbiddenResponseSchema = PermissionStateSchema.extend({
  error: z.literal('forbidden'),
});
export type ForbiddenResponse = z.infer<typeof ForbiddenResponseSchema>;
